import React from 'react';
import { Box } from '@material-ui/core';
import { Subtitle, H3, Container, ContainerItem, TrustCertificates } from 'react-design-components';
import clsx from 'clsx';
import useGreeting from './hooks/useGreeting';

interface Props {
  displayGreeting?: boolean;
}

const Greeting: React.FC<Props> = ({ displayGreeting, children }: any) => {
  const { t, classes } = useGreeting(displayGreeting);
  return (
    <>
      <Container>
        <ContainerItem
          noPadding
          container
          justify="center"
          className={clsx([classes.trustCertificatesContainer, classes.trustCertificatesContainerAbove])}
        >
          <TrustCertificates />
        </ContainerItem>
      </Container>
      <Container justify="flex-start">
        <ContainerItem noPadding className={classes.greetingContainer}>
          <Box mb={4}>
            <H3>{t('title')}</H3>
          </Box>
          <Box mb={4}>
            <Subtitle>{t('description')}</Subtitle>
          </Box>
        </ContainerItem>
      </Container>
      {children}
      <Container>
        <ContainerItem
          noPadding
          container
          justify="center"
          className={clsx([classes.trustCertificatesContainer, classes.trustCertificatesContainerBelow])}
        >
          <TrustCertificates />
        </ContainerItem>
      </Container>
    </>
  );
};

export default Greeting;
